import { render } from "./BarPassageOutcomes.vue?vue&type=template&id=535c7456&scoped=true"
import script from "./BarPassageOutcomes.vue?vue&type=script&lang=js"
export * from "./BarPassageOutcomes.vue?vue&type=script&lang=js"

import "./BarPassageOutcomes.vue?vue&type=style&index=0&id=535c7456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535c7456"]])

export default __exports__